import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaMedal, FaUsers, FaWarehouse, FaCalendarAlt, FaClock, FaArrowRight } from 'react-icons/fa';
import PageHero from '../components/PageHero';

const facts = [
  { icon: <FaUsers />,      label: 'Employees',          value: '100+' },
  { icon: <FaWarehouse />,  label: 'Total Facility',     value: '172K sq.ft.' },
  { icon: <FaCalendarAlt />,label: 'Founded',            value: '2016' },
  { icon: <FaClock />,      label: 'Domain Experience',  value: '20+ Years' },
];

const certs = [
  { name: 'ISO 9001:2015', issuer: 'TUV SUD',           scope: 'PCBA, Wiring Harness & Box Build Manufacturing' },
  { name: 'ZED Bronze',    issuer: 'Ministry of MSME',  scope: 'Zero Defect Zero Effect Certification' },
  { name: 'MSME Lean',     issuer: 'Govt. of India',    scope: 'Competitive Lean Scheme Certificate' },
  { name: 'Kaizen Award',  issuer: 'Schneider Electric', scope: 'Recipient 2021, 2022 & 2023' },
];

const upcoming = ['ISO 14001', 'ISO 45001', 'ISO 13485', 'AS 9100'];

const pillars = [
  'Defect-Free Quality — IPC Class II & III Capable',
  'Scalable Production — 10 units to 100,000+ runs',
  'Full Traceability — PanaCIM on all SMT lines',
  'Rapid NPI — DFX support from design to production',
  'Integrity & Teamwork — transparent partnership',
  'Make in India — robust in-house capabilities',
];

const offerings = [
  'Design (DFX)',
  'Engineering & Development (Proto/NPI)',
  'Series Manufacturing',
  'Box Build / Turnkey Manufacturing',
  'Support Services (Logistics, Repair, SCM)',
];

export default function About() {
  return (
    <div style={{ background: '#0a0a0f', color: '#e2e8f0', fontFamily: 'Inter, sans-serif' }}>
      <PageHero
        chip="Corporate Identity"
        title="Safer, Smarter & Sustainable"
        subtitle="Saalfo Tech Pvt Ltd is Mysore's fastest-growing EMS company — part of a conglomerate with over 35 years of experience."
      />

      {/* SECTION 1: THE "NIGHT-MODE" OVERVIEW */}
    <section style={{ 
  padding: '100px 0', 
  background: `
    linear-gradient(rgba(0,0,0,0.75), rgba(0,0,0,0.85)),
    url('https://mlo4pd3pemqf.i.optimole.com/cb:ObNP.bbc/w:980/h:653/q:mauto/ig:avif/https://podrain.com/wp-content/uploads/2025/02/Ultimate-Guide-Featured-IMage.jpeg') center/cover no-repeat
  `,
  borderBottom: '1px solid rgba(255,255,255,0.05)'
}}>
  <div
    className="wrap"
    style={{
      width: '100%',
      maxWidth: '100%',
      padding: '0 24px'
    }}
  >
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:80, alignItems:'center' }} className="about-grid">
      
      {/* Your existing left content remains the same */}
      <div className="reveal">
        <div style={{ borderLeft: '4px solid #5cb85c', paddingLeft: '24px', marginBottom: '30px' }}>
          <span style={{ color: '#5cb85c', fontWeight: 800, fontSize: '12px', letterSpacing: '2px', textTransform: 'uppercase' }}>Who We Are</span>
          <h2 style={{ fontSize: '42px', fontWeight: 800, color: '#fff', marginTop: '10px', fontFamily: 'Rajdhani' }}>An Integrated EMS Partner</h2>
        </div>
        
        <p style={{ fontSize: '17px', lineHeight: '1.8', color: '#94a3b8', marginBottom: '20px' }}>
          SAALFO is part of a successful business conglomerate that has over 35 years of experience founding, developing, and maintaining flourishing businesses across Electronics Manufacturing Services, Education, and Textiles.
        </p>
        
        <p style={{ fontSize: '17px', lineHeight: '1.8', color: '#94a3b8', marginBottom: '35px' }}>
          Our long-term strategy supports the <b style={{color:'#fff'}}>'Make in India'</b> initiative by building robust in-house bare PCB, critical electronic components design, and manufacturing facilities.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
          {pillars.map(p => (
            <div key={p} style={{ background: 'rgba(255,255,255,0.03)', padding: '15px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.05)', fontSize: '13px', display: 'flex', gap: '10px' }}>
              <FaCheckCircle style={{ color: '#5cb85c', marginTop: '3px' }}/> {p.split('—')[0]}
            </div>
          ))}
        </div>
      </div>

      {/* Right side remains same */}
      <div style={{ position: 'relative' }}>
        <div className="g2" style={{ gap: '20px' }}>
          {facts.map((f, i) => (
            <div key={f.label} style={{ 
              background: i % 2 === 0 ? '#11111a' : '#5cb85c', 
              padding: '40px 30px', 
              borderRadius: '24px',
              color: i % 2 === 0 ? '#fff' : '#000',
              transform: i % 2 === 0 ? 'translateY(0)' : 'translateY(30px)',
              boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
            }}>
              <div style={{ fontSize: '24px', marginBottom: '15px' }}>{f.icon}</div>
              <div style={{ fontSize: '32px', fontWeight: 800, fontFamily: 'Rajdhani' }}>{f.value}</div>
              <div style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', opacity: 0.8 }}>{f.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
</section>

      {/* SECTION 2: THE "VISION" SCROLLING BREAK */}
     <section style={{ 
  padding: '120px 0 100px 0',
  background: '#f8fafc',
  position: 'relative',
  overflow: 'hidden',
  borderTop: '1px solid rgba(92, 184, 92, 0.2)',
  borderBottom: '1px solid rgba(92, 184, 92, 0.2)'
}}>
  
  {/* Stronger Zigzag Background */}
  <div style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: `
      linear-gradient(135deg, rgba(92, 184, 92, 0.12) 25%, transparent 25%) -60px 0 / 100px 100px,
      linear-gradient(135deg, transparent 75%, rgba(92, 184, 92, 0.12) 75%) -60px 0 / 100px 100px
    `,
    opacity: 1,
    zIndex: 1
  }}></div>

  <div className="wrap" style={{ 
    textAlign: 'center', 
    maxWidth: '920px', 
    margin: '0 auto', 
    padding: '0 24px',
    position: 'relative',
    zIndex: 2
  }}>
    
    <div style={{ marginBottom: '40px' }}>
      <span style={{ 
        color: '#5cb85c', 
        fontWeight: 800, 
        fontSize: '13px', 
        letterSpacing: '3.5px', 
        textTransform: 'uppercase',
        background: 'rgba(92, 184, 92, 0.1)',
        padding: '10px 28px',
        borderRadius: '50px',
        border: '1px solid rgba(92, 184, 92, 0.3)'
      }}>
        CORPORATE VISION
      </span>
    </div>

    <h2 style={{ 
      fontSize: '34px', 
      lineHeight: '1.55', 
      color: '#1e2937', 
      fontWeight: 500,
      fontFamily: 'Rajdhani, sans-serif'
    }}>
      "To set up a world class manufacturing facility inspired by{' '}
      <span style={{ 
        color: '#166534', 
        fontWeight: 700, 
        borderBottom: '3px solid #5cb85c',
        paddingBottom: '6px'
      }}>
        innovations
      </span>, 
      advanced engineering and smart technologies."
    </h2>

    <div style={{ 
      width: '90px', 
      height: '4px', 
      background: 'linear-gradient(90deg, transparent, #5cb85c, transparent)', 
      margin: '50px auto 0' 
    }}></div>
  </div>
</section>

      {/* SECTION 3: OFFERINGS (GLASSMORPHIC CARDS) */}
    <section style={{ 
  padding: '100px 0', 
  background: '#f8fafc',
  position: 'relative',
  overflow: 'hidden'
}}>
  
  {/* Background Pattern */}
  <div style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: `
      repeating-linear-gradient(135deg, rgba(92, 184, 92, 0.06) 0px, rgba(92, 184, 92, 0.06) 2px, transparent 2px, transparent 40px),
      repeating-linear-gradient(45deg, rgba(92, 184, 92, 0.04) 0px, rgba(92, 184, 92, 0.04) 1px, transparent 1px, transparent 60px)
    `,
    zIndex: 1
  }}></div>

  <div
    className="wrap"
    style={{
      width: '100%',
      maxWidth: '100%',
      padding: '0 24px',
      position: 'relative',
      zIndex: 3
    }}
  >
    <h2 style={{ 
      textAlign: 'center', 
      fontSize: '38px', 
      fontWeight: 800, 
      marginBottom: '70px', 
      fontFamily: 'Rajdhani',
      color: '#1e2937'
    }}>
      Service Architecture
    </h2>

    <div style={{ 
      display: 'grid', 
      gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', 
      gap: '24px' 
    }} className="about-grid">
      
      {offerings.map((o, i) => {
        // Different light colors for each box
        const colors = [
          { bg: '#f0fdf4', border: '#86efac', number: '#4ade80' },   // Light Green
          { bg: '#f0f9ff', border: '#7dd3fc', number: '#38bdf8' },   // Light Blue
          { bg: '#f5f3ff', border: '#c4b5fd', number: '#a78bfa' },   // Light Purple
          { bg: '#fefce8', border: '#fde047', number: '#eab308' },   // Light Yellow
          { bg: '#fef2f2', border: '#fda4af', number: '#fb7185' }    // Light Rose
        ];
        const c = colors[i % colors.length];

        return (
          <div 
            key={o} 
            style={{ 
              background: c.bg, 
              border: `1px solid ${c.border}`, 
              padding: '40px 25px', 
              borderRadius: '20px',
              textAlign: 'center',
              transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-12px)';
              e.currentTarget.style.boxShadow = '0 20px 35px rgba(92, 184, 92, 0.15)';
              e.currentTarget.style.borderColor = '#5cb85c';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.05)';
              e.currentTarget.style.borderColor = c.border;
            }}
          >
            {/* Number Badge */}
            <div style={{ 
              color: '#fff', 
              background: c.number, 
              width: '52px', 
              height: '52px', 
              borderRadius: '50%', 
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '19px', 
              fontWeight: 800, 
              margin: '0 auto 24px',
              boxShadow: '0 8px 15px rgba(0,0,0,0.1)'
            }}>
              {String(i+1).padStart(2, '0')}
            </div>

            {/* Service Title */}
            <div style={{ 
              fontSize: '15.5px', 
              fontWeight: 600, 
              color: '#1e2937', 
              lineHeight: '1.5',
              minHeight: '50px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {o}
            </div>
          </div>
        );
      })}
    </div>
  </div>
</section>

      {/* SECTION 4: CERTIFICATIONS (3D DEPTH STYLE) */}
      <section style={{ padding: '100px 0', background: '#0f0f16' }}>
        <div
  className="wrap"
  style={{
    width: '100%',
    maxWidth: '100%',
    padding: '0 24px'
  }}
>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '50px' }}>
            <div>
              <span style={{ color: '#5cb85c', fontWeight: 800, fontSize: '12px' }}>VALIDATION</span>
              <h2 style={{ fontSize: '36px', fontWeight: 800, color: '#fff', fontFamily: 'Rajdhani' }}>Quality Benchmarks</h2>
            </div>
            <div style={{ color: '#5cb85c', fontWeight: 600, fontSize: '14px' }}>Industry Compliancee →</div>
          </div>

          <div className="g4">
            {certs.map(c => (
              <div key={c.name} style={{ 
                background: '#161621', 
                padding: '40px 30px', 
                borderRadius: '2px', 
                borderLeft: '1px solid rgba(255,255,255,0.05)',
                borderBottom: '4px solid #5cb85c'
              }}>
                <FaMedal style={{ color: '#5cb85c', fontSize: '30px', marginBottom: '20px' }}/>
                <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#fff', marginBottom: '10px' }}>{c.name}</h3>
                <p style={{ fontSize: '11px', color: '#5cb85c', fontWeight: 800, marginBottom: '15px' }}>{c.issuer}</p>
                <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.5' }}>{c.scope}</p>
              </div>
            ))}
          </div>

          <div style={{ marginTop: '40px', background: 'linear-gradient(90deg, #1a1a2e, #0a0a0f)', padding: '40px', borderRadius: '15px', border: '1px solid #1e1e30' }}>
             <h4 style={{ color: '#fff', marginBottom: '20px', fontSize: '14px', fontWeight: 700 }}>Upcoming Roadmap 2026-27</h4>
             <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                {upcoming.map(u => (
                  <span key={u} style={{ border: '1px solid #5cb85c', color: '#5cb85c', padding: '8px 20px', borderRadius: '100px', fontSize: '12px', fontWeight: 700 }}>{u}</span>
                ))}
             </div>
          </div>
        </div>
      </section>

      {/* SECTION 5: CTA */}
      <section style={{ 
  padding: '130px 0', 
  background: '#ffffff',
  position: 'relative',
  overflow: 'hidden'
}}>
  
  {/* Strong Manufacturing-Tech Background Design */}
  <div style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: `
      linear-gradient(135deg, rgba(92, 184, 92, 0.07) 0%, transparent 50%),
      repeating-linear-gradient(45deg, transparent, transparent 30px, rgba(92, 184, 92, 0.08) 30px, rgba(92, 184, 92, 0.08) 32px),
      repeating-linear-gradient(135deg, transparent, transparent 50px, rgba(92, 184, 92, 0.06) 50px, rgba(92, 184, 92, 0.06) 52px)
    `,
    zIndex: 1
  }}></div>

  {/* Large Subtle Circuit Pattern */}
  <div style={{
    position: 'absolute',
    top: '-20%',
    left: '-20%',
    width: '140%',
    height: '140%',
    background: 'radial-gradient(circle, rgba(92, 184, 92, 0.05) 1px, transparent 1px)',
    backgroundSize: '60px 60px',
    opacity: 0.6,
    zIndex: 1
  }}></div>

  <div
    className="wrap"
    style={{
      width: '100%',
      maxWidth: '740px',
      margin: '0 auto',
      padding: '0 24px',
      textAlign: 'center',
      position: 'relative',
      zIndex: 2
    }}
  >
    <h2 style={{ 
      color: '#0f172a', 
      fontSize: '46px', 
      fontWeight: 800, 
      fontFamily: 'Rajdhani',
      lineHeight: '1.1',
      marginBottom: '24px'
    }}>
      Ready to Scale Your Manufacturing?
    </h2>
    
    <p style={{ 
      color: '#475569', 
      fontSize: '18.5px', 
      lineHeight: '1.7',
      marginBottom: '50px',
      maxWidth: '520px',
      marginLeft: 'auto',
      marginRight: 'auto'
    }}>
      Talk to our BD team about your project requirements and get a custom EMS solution.
    </p>

    <Link 
      to="/contact" 
      style={{ 
        background: '#5cb85c', 
        color: '#ffffff', 
        padding: '22px 58px', 
        borderRadius: '60px', 
        textDecoration: 'none', 
        fontWeight: 700,
        fontSize: '15.5px',
        textTransform: 'uppercase',
        letterSpacing: '2.5px',
        display: 'inline-block',
        transition: 'all 0.4s ease',
        boxShadow: '0 12px 35px rgba(92, 184, 92, 0.3)'
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = 'translateY(-4px)';
        e.target.style.boxShadow = '0 18px 40px rgba(92, 184, 92, 0.4)';
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = 'translateY(0)';
        e.target.style.boxShadow = '0 12px 35px rgba(92, 184, 92, 0.3)';
      }}
    >
      Get in Touch Now
    </Link>
  </div>
</section>

      <style>{`
        .wrap { max-width: 1200px; margin: 0 auto; padding: 0 24px; }
        .g2 { display: grid; grid-template-columns: 1fr 1fr; }
        .g4 { display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; }
        @media(max-width:768px){ 
          .about-grid, .g4 { grid-template-columns: 1fr !important; } 
          .g2 { grid-template-columns: 1fr 1fr !important; }
        }
      `}</style>
    </div>
  );
}   